<nav class="position-relative mt-3">
  <ul>
    @for (definition of menuItems | async; track definition) {
      <li>
        <app-dashboard-item [definition]="definition" [viewType]="1"></app-dashboard-item>
      </li>
    }
  </ul>
</nav>
